import { render, staticRenderFns } from "./Site.vue?vue&type=template&id=781b6610"
import script from "./Site.vue?vue&type=script&lang=js"
export * from "./Site.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781b6610')) {
      api.createRecord('781b6610', component.options)
    } else {
      api.reload('781b6610', component.options)
    }
    module.hot.accept("./Site.vue?vue&type=template&id=781b6610", function () {
      api.rerender('781b6610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/Site.vue"
export default component.exports